export default __webpack_public_path__ + "static/media/patrick.de4a5062.jpg";